<template>
  <form @submit.prevent="handleSubmit(item)">
    <!--<b-row>-->
      <!--<b-col>-->
        <!--<div class="form-group">-->
          <!--<label-->
                  <!--for="excmagreementconsent_consent"-->
                  <!--class="form-control-label">consent</label>-->
          <!--<input-->
                  <!--id="excmagreementconsent_consent"-->
                  <!--v-model="item.consent"-->
                  <!--:class="['form-control', isInvalid('consent') ? 'is-invalid' : '']"-->
                  <!--type="text"-->
                  <!--required="true"-->
                  <!--placeholder=""-->
                  <!--@input="handleUpdateField('consent', $event.target.value)">-->
          <!--<div-->
                  <!--v-if="isInvalid('consent')"-->
                  <!--class="invalid-feedback">{{ violations.consent }}</div>-->
        <!--</div>-->
      <!--</b-col>-->
    <!--</b-row>-->
    <b-row>
      <b-col>
        <div class="form-group">
          <label
                  for="excmagreementconsent_agree"
                  class="form-control-label">{{ $t('views.excmagreementconsent.form.agree') }}:</label>
          <el-select
                  class="select-default"
                  v-model="item.agree"
                  :placeholder="$t('views.excmcase.list.searchParams.statusPlaceholder')">
            <el-option
                    class="select-default"
                    v-for="item in yesNoOptions"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
            </el-option>
          </el-select>
          <div
                  v-if="isInvalid('agree')"
                  class="invalid-feedback">{{ violations.agree }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
        <b-btn variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      yesNoOptions: [
        {
          value: 0,
          text: this.$t('buttons.no')
        },
        {
          value: 1,
          text: this.$t('buttons.yes')
        }
      ]
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    closeModal () {
      this.$store.state.modals.excmagreementconsent.update.close = 1
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
